import { render, staticRenderFns } from "./orderContent.vue?vue&type=template&id=dd6367a8&"
import script from "./orderContent.vue?vue&type=script&lang=js&"
export * from "./orderContent.vue?vue&type=script&lang=js&"
import style0 from "./orderContent.vue?vue&type=style&index=0&id=dd6367a8&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports